import React, { CSSProperties, useMemo } from "react";
import toast from "react-hot-toast";
import { api, CompanyEmployeeDto, CompanyEmployeeRoleDto } from "shared/api";
import { getErrorMessage } from "shared/lib/error-message";
import { Avatar, Entity, Select } from "shared/ui";

export interface IEmployeeEntity {
  data: CompanyEmployeeDto;
  menuItems?: React.ReactNode;

  companySlug: string;
  companyOwnerId?: string;
  roles?: CompanyEmployeeRoleDto[];

  readOnly?: boolean;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EmployeeEntity = (props: IEmployeeEntity) => {
  const roleOptions = useMemo(() => props.roles?.map((it) => ({ value: it.id, label: it.name })), [props.roles]);

  const isOwner = props.data.user.id === props.companyOwnerId;
  const canChange = !props.readOnly && !isOwner;

  const onRoleChange = async (newRoleId: string) => {
    try {
      await api.companyEmployee.companyEmployeeChangeRole(props.companySlug, props.data.id, {
        roleId: newRoleId,
      });
    } catch (e) {
      const error = await getErrorMessage(e);
      toast.error(error.message);
    }
  };

  return (
    <Entity className={props.className} style={props.style} htmlId={props.htmlId} menuItems={props.menuItems}>
      <Entity.Field
        avatar={
          <Avatar
            name={props.data.user.name || props.data.user.email}
            id={props.data.user.id}
            image={props.data.user.avatarImage}
          />
        }
        title={props.data.user.name || props.data.user.email}
        description={props.data.user.email}
      />

      {!canChange && <Entity.Field description={props.data.companyEmployeeRole.name} right />}
      {canChange && (
        <Entity.Field right>
          <Select options={roleOptions} value={props.data.companyEmployeeRole.id} onChange={onRoleChange} />
        </Entity.Field>
      )}
    </Entity>
  );
};

EmployeeEntity.defaultProps = {};
